module.exports = __webpack_public_path__ + "static/media/logo.fbdec655.svg";